// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2r3IK","addWidgetButton":"Header_addWidgetButton__3thQ2","dashboardTabs":"Header_dashboardTabs__3xvbE","active":"Header_active__1fdW9"};